// Mock data for TOLSOL website
import toldoComunidadesImg from '../assets/projects/toldo-comunidades.jpg';
import toldoTerrazaImg from '../assets/projects/toldo-terraza.jpg';
import pergolaCorrederaImg from '../assets/projects/pergola-corredera.jpg';
import toldoExteriorImg from '../assets/projects/toldo-exterior.jpg';
import pergolaBioclimaticaBlogImg from '../assets/projects/pergola-bioclimatica-blog.jpg';
import blogToldoTerrazaImg from '../assets/projects/blog-toldo-terraza.jpg';
import blogToldoMantenimientoImg from '../assets/projects/blog-toldo-mantenimiento.jpg';
import toldoComercialRestauranteImg from '../assets/projects/toldo-comercial-restaurante.jpg';
import toldoTerrazaChaletImg from '../assets/projects/toldo-terraza-chalet.jpg';
import toldoBalconImg from '../assets/projects/toldo-balcon.jpg';
import toldoGrande from '../assets/projects/toldo-grande.jpg';

export const services = [
  {
    id: 1,
    title: 'Toldos para terrazas, chalets y jardines',
    description:
      'Disponemos del toldo perfecto para tu terraza o jardin. Ofrecemos distintas soluciones segun el espacio y la estetica de tu hogar.',
    features: [
      'Toldos tradicionales',
      'Toldo de brazos articulados',
      'Toldos planos y pergolas',
      'Pergolas bioclimaticas con domotica',
      'Sistemas de cofre para proteccion',
      'Monitorizacion de toldos',
      'Reparacion, mantenimiento y sustitucion de lonas',
    ],
    image: toldoTerrazaChaletImg,
  },
  {
    id: 2,
    title: 'Toldos y estores para ventanas y balcones',
    description:
      'Protege tu hogar del sol, mejora la eficiencia energetica y gana privacidad con nuestros toldos y estores.',
    features: [
      'Toldos capota y capota abatible',
      'Sistemas verticales screen o zip',
      'Estores interiores y exteriores',
      'Monitorizacion de toldos',
      'Reparacion y sustitucion de lonas',
    ],
    image: toldoBalconImg,
  },
  {
    id: 3,
    title: 'Toldos para comercios, bares y restaurantes',
    description:
      'Soluciones a medida para locales comerciales, cerramientos y pergolas. Protege y amplia la superficie de tu negocio.',
    features: [
      'Toldo extensible',
      'Capota decorativa',
      'Pergolas y lonas cortaviento',
      'Pergolas bioclimaticas',
      'Motorizaciones Somfy',
      'Reparaciones y sustituciones',
    ],
    image: toldoComercialRestauranteImg,
  },
  {
    id: 4,
    title: 'Motores, automatismos y domotica',
    description:
      'Automatiza tus toldos y persianas con sistemas inteligentes que responden al sol, viento y temperatura.',
    features: [
      'Motores Somfy',
      'Control remoto o app movil',
      'Domotica para iluminacion y confort',
      'Sensor sol/viento',
      'Integracion con Alexa y Google Home',
    ],
    image: 'https://customer-assets.emergentagent.com/job_smart-shade-1/artifacts/49iaov7j_image.png',
  },
  {
    id: 5,
    title: 'Toldos y lonas para grandes superficies',
    description: 'Soluciones de gran formato para centros comerciales, naves y terrazas amplias.',
    features: [
      'Toldos verticales para cierre de locales',
      'Toldos planos a medida',
      'Toldos automatizados',
      'Lonas industriales reforzadas',
      'Servicio tecnico y mantenimiento urgente',
    ],
    image: toldoGrande,
  },
];

export const projects = [
  {
    id: 1,
    title: 'Toldo Comercial - Bar Miguel',
    category: 'Comercial',
    image: 'https://customer-assets.emergentagent.com/job_smart-shade-1/artifacts/vfrcx4jx_image.png',
    description: 'Toldo extensible para bar con sistema de proteccion completo.',
  },
  {
    id: 2,
    title: 'Toldo Residencial Moderno',
    category: 'Residencial',
    image: 'https://customer-assets.emergentagent.com/job_smart-shade-1/artifacts/7dc0my7w_image.png',
    description: 'Toldo de brazos articulados con cofre para chalet.',
  },
  {
    id: 3,
    title: 'Estor Vertical Screen',
    category: 'Residencial',
    image: 'https://customer-assets.emergentagent.com/job_smart-shade-1/artifacts/ccx6d3to_image.png',
    description: 'Sistema vertical con domotica integrada para terraza.',
  },
  {
    id: 4,
    title: 'Toldo de Brazos Articulados',
    category: 'Residencial',
    image: 'https://customer-assets.emergentagent.com/job_smart-shade-1/artifacts/49iaov7j_image.png',
    description: 'Instalacion en terraza de chalet con control remoto.',
  },
  {
    id: 5,
    title: 'Pergola Industrial',
    category: 'Industrial',
    image: 'https://customer-assets.emergentagent.com/job_smart-shade-1/artifacts/vjnleqei_image.png',
    description: 'Cubierta de gran formato para nave industrial.',
  },
  {
    id: 6,
    title: 'Toldo para comunidades',
    category: 'Residencial',
    image: toldoComunidadesImg,
    description:
      'Instalacion coordinada de toldos acrilicos color mostaza en fachada comunitaria con motorizacion centralizada y refuerzos antiviento.',
  },
  {
    id: 7,
    title: 'Toldo para terraza',
    category: 'Residencial',
    image: toldoTerrazaImg,
    description:
      'Toldo motorizado de gran formato con lona microperforada blanca para terraza ajardinada, integrado con estructura existente.',
  },
  {
    id: 8,
    title: 'Pergola corredera',
    category: 'Residencial',
    image: pergolaCorrederaImg,
    description:
      'Pergola corredera manual con tejido tecnico translucido, instalada bajo vigas de hormigon para crear sombra regulable en atico.',
  },
  {
    id: 9,
    title: 'Toldo exterior para piscina',
    category: 'Comercial',
    image: toldoExteriorImg,
    description:
      'Toldo a rayas verdes y crema para zona de piscina interior con estructura articulada y tejido acrilico de alta resistencia.',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Javier',
    location: 'Madrid',
    rating: 5,
    text: 'Instalaron una pergola bioclimatica en mi terraza. Quedo perfecta, elegante y funcional.',
  },
  {
    id: 2,
    name: 'Carmen',
    location: 'Toledo',
    rating: 5,
    text: 'Calidad excelente, plazos cumplidos y trato impecable.',
  },
  {
    id: 3,
    name: 'Roberto',
    location: 'Madrid',
    rating: 5,
    text: 'Llevamos trabajando con TOLSOL desde hace años en nuestro restaurante. Servicio profesional y rapido.',
  },
];

export const blogPosts = [
  {
    id: 1,
    slug: 'como-elegir-el-mejor-toldo-para-tu-terraza',
    title: 'Como elegir el mejor toldo para tu terraza',
    excerpt: 'Guia completa para seleccionar el toldo ideal segun el espacio, orientacion y necesidades...',
    date: '2025-01-15',
    image: blogToldoTerrazaImg,
    content: [
      'El toldo perfecto depende del espacio disponible, la orientacion de la fachada y el uso que vayas a darle. En terrazas amplias un toldo extensible ofrece gran cobertura, mientras que para balcones estrechos son mas apropiados los modelos verticales.',
      'La lona determina la duracion del toldo. Las lonas acrilicas aportan buena resistencia a los rayos UV y mantienen el color durante años. Si la terraza esta expuesta al viento conviene optar por sistemas con cofres y brazos reforzados.',
      'No olvides la automatizacion. Los sensores de sol y viento prolongan la vida del toldo y mejoran el confort. Un instalador profesional podra asesorarte sobre la solucion mas adecuada segun tu presupuesto y necesidades.',
    ],
  },
  {
    id: 2,
    slug: 'ventajas-de-las-pergolas-bioclimaticas-modernas',
    title: 'Ventajas de las pergolas bioclimaticas modernas',
    excerpt: 'Descubre como la tecnologia bioclimatica puede transformar tu espacio exterior...',
    date: '2025-01-10',
    image: pergolaBioclimaticaBlogImg,
    content: [
      'Las pergolas bioclimaticas permiten regular la entrada de luz y ventilacion gracias a sus lamas orientables. Con un simple mando a distancia podras abrirlas para disfrutar del sol o cerrarlas para protegerte de la lluvia.',
      'Una pergola de este tipo mejora la eficiencia energetica del hogar: reduce la incidencia directa del sol sobre el interior de la vivienda y mantiene una temperatura mas estable. Ademas, su estructura de aluminio requiere muy poco mantenimiento.',
      'La integracion con domotica es otro punto fuerte. Puedes programar la apertura automatica cuando detecten viento fuerte, controlar la iluminacion integrada o gestionarla desde tu movil. Es una inversion que convierte cualquier terraza en un espacio habitable durante todo el ano.',
    ],
  },
  {
    id: 3,
    slug: 'guia-rapida-de-mantenimiento-de-lonas',
    title: 'Guia rapida de mantenimiento de lonas',
    excerpt: 'Consejos profesionales para mantener tus toldos en perfecto estado durante años...',
    date: '2025-01-05',
    image: blogToldoMantenimientoImg,
    content: [
      'Una limpieza suave dos veces al año es suficiente para alargar la vida de la lona. Utiliza agua tibia y jabon neutro, evitando siempre los productos abrasivos que puedan danar los tratamientos impermeables.',
      'Tras episodios de lluvia deja secar el toldo completamente antes de recogerlo para evitar la aparicion de moho. Si detectas manchas resistentes, insiste con un cepillo suave sin aplicar demasiada presion.',
      'Revisa los mecanismos periodicamente: engrasa los puntos de giro, comprueba la tension del tejido y detecta cualquier dano en los anclajes. Ante cualquier deterioro importante, contacta con un tecnico especializado para reemplazar la lona o ajustar los brazos.',
    ],
  },
];

export const stats = [
  { value: '+30', label: 'Años de experiencia' },
  { value: '+2500', label: 'Instalaciones realizadas' },
  { value: '98%', label: 'Satisfaccion del cliente' },
];

export const certifications = [
  'Materiales certificados segun normativa europea',
  'Garantia de 2 años en todos nuestros productos',
  'Cumplimiento de estandares de resistencia y durabilidad',
  'Instalaciones certificadas por tecnicos especializados',
];

export const contactInfo = {
  email: 'info@tolsol.es',
  phone: '91 552 76 99',
  mobile: '696 21 23 13',
  address: 'Calle Libertad, 29',
  city: '28936 Madrid',
  schedule: 'Lunes a viernes de 9:00 a 19:00',
};
